import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function Essence() {
  const { ref: titleRef, isVisible: titleVisible } = useScrollReveal(0.1);
  const { ref: cardsRef, isVisible: cardsVisible } = useScrollReveal(0.1);

  const values = [
    {
      icon: 'ri-heart-3-line',
      title: 'Amor pelo Propósito',
      description: 'Cuidamos do seu projeto como a semente de um ecossistema digital sustentável. Nosso foco é o branding com propósito, garantindo que cada ação reflita a verdade do seu negócio.'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Liderança Ágil',
      description: 'Velocidade estratégica para superar a concorrência. Aplicamos metodologias ágeis para garantir que sua empresa acompanhe o ritmo do mercado digital sem perder a essência.'
    },
    {
      icon: 'ri-star-line',
      title: 'Unicidade Absoluta',
      description: 'O compromisso de tornar sua empresa uma autoridade incomparável. Criamos estratégias exclusivas para que sua marca se destaque através de um posicionamento de mercado único e memorável.'
    }
  ];

  return (
    <section id="essence" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">

        <div
          ref={titleRef}
          className={`text-center mb-20 transition-all duration-800 ease-out ${
            titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
          }`}
          style={{ transitionDuration: '800ms' }}
        >
          <h2 className="text-4xl md:text-5xl font-extralight text-gray-900 mb-6">
            O Coração da <span className="font-light text-purple-600">Inovação</span>
          </h2>
          <div className="w-20 h-0.5 bg-purple-600 mx-auto mb-8"></div>
          <p className="text-lg md:text-xl text-gray-600 font-light leading-relaxed max-w-4xl mx-auto">
            Na Soul One Digital, não entregamos apenas serviços; construímos o posicionamento estratégico
            de marcas que buscam propósito. Somos o parceiro ideal para empreendedores que desejam humanizar
            sua tecnologia e criar conexões reais. Nossa essência é a escuta ativa: transformamos o que sua
            marca silencia na voz que o mercado precisa ouvir, unindo sensibilidade e resultados.
          </p>
        </div>

        <div ref={cardsRef} className="grid grid-cols-1 md:grid-cols-3 gap-12 mt-20">
          {values.map((value, index) => (
            <div
              key={index}
              className={`group text-center p-10 rounded-2xl bg-gradient-to-br from-gray-50 to-white border border-gray-100 hover:border-purple-200 transition-all duration-300 hover:shadow-xl ${
                cardsVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-16'
              }`}
              style={{
                transitionProperty: 'opacity, transform',
                transitionDuration: '700ms',
                transitionTimingFunction: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                transitionDelay: cardsVisible ? `${index * 180}ms` : '0ms',
              }}
            >
              <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 rounded-full bg-purple-100 group-hover:bg-purple-600 transition-all duration-300">
                <i className={`${value.icon} text-4xl text-purple-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-xl font-light text-gray-900 mb-4">{value.title}</h3>
              <p className="text-gray-600 font-light leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
